import React from 'react'
import './opportunity-spotlight.scss'

export interface OpportunitySpotlightProps {
  title: string
  description: string
  category: string
  minInvestment: string
  onInvestClick: () => void
  testIdPrefix: 'home-v2' | 'opportunities-v2'
}

/** Hero banner for the opportunity flagged with metadata.highlight_enabled. */
export const OpportunitySpotlight: React.FC<OpportunitySpotlightProps> = ({
  title,
  description,
  category,
  minInvestment,
  onInvestClick,
  testIdPrefix,
}) => (
  <section
    className='opportunities-v2__spotlight'
    aria-label='Highlighted opportunity'
    data-testid={`${testIdPrefix}-spotlight`}
  >
    <div className='opportunities-v2__spotlight-inner'>
      <div className='opportunities-v2__spotlight-copy'>
        <span className='opportunities-v2__spotlight-eyebrow'>
          <span className='opportunities-v2__spotlight-dot' aria-hidden />
          NOW LIVE
        </span>
        <h2 className='opportunities-v2__spotlight-title'>{title} is now open for investment</h2>
        <p className='opportunities-v2__spotlight-description'>{description}</p>
        <div className='opportunities-v2__spotlight-actions'>
          <button
            type='button'
            className='opportunities-v2__spotlight-btn opportunities-v2__spotlight-btn--primary'
            onClick={onInvestClick}
          >
            Invest now <span aria-hidden>→</span>
          </button>
        </div>
        <p className='opportunities-v2__spotlight-disclaimer'>
          Investing involves risk, including partial or total loss of capital.
        </p>
      </div>
      <div className='opportunities-v2__spotlight-panel'>
        <div className='opportunities-v2__spotlight-panel-head'>
          <span className='opportunities-v2__spotlight-wordmark'>{title}</span>
          <span className='opportunities-v2__spotlight-live'>
            <span className='opportunities-v2__spotlight-dot' aria-hidden />
            Live
          </span>
        </div>
        <dl className='opportunities-v2__spotlight-stats'>
          <div>
            <dt>Asset class</dt>
            <dd>{category}</dd>
          </div>
          <div>
            <dt>Min. investment</dt>
            <dd>{minInvestment}</dd>
          </div>
          <div>
            <dt>Status</dt>
            <dd className='opportunities-v2__spotlight-status'>Open</dd>
          </div>
        </dl>
      </div>
    </div>
  </section>
)
